export default "__VITE_ASSET__bf245795__"